<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">ID</div>
        <el-input v-model="detail.ibid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">月份</div>
        <el-input v-model="detail.inmonth" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">项目</div>
        <el-input v-model="detail.project" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">项目链接</div>
        <el-input v-model="detail.link" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">订单号</div>
        <el-input v-model="detail.orderid" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">分类</div>
        <el-radio-group v-model="detail.category">
          <div class="dib mr-20">
            <el-radio :label="item.value" v-for="(item, index) in categoryList" :key="index">{{item.name}}</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">品牌</div>
        <el-input v-model="detail.brand" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">商品</div>
        <el-input v-model="detail.commodity" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">生产日期</div>
        <el-input v-model="detail.product_date" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">保质期</div>
        <el-input v-model="detail.effective_date" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">原价</div>
        <el-input v-model="detail.original_price" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">成本</div>
        <el-input v-model="detail.cost_price" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">代理价</div>
        <el-input v-model="detail.agent_price" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">售出包邮价</div>
        <el-input v-model="detail.sale_price" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">库存</div>
        <el-input v-model="detail.stock" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">备注</div>
        <el-input v-model="detail.remark" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="inboundEdit">保存</button>
      </div>
    </div>
  </article>
</template>

<script>
import util from '../../../script/util'
import {inboundDetail, inboundEdit} from '../../../api/api'
export default {
  name: 'inboundEdit',
  data () {
    return {
      detail: {
        ibid: 0,
        project: '',
        link: '',
        inmonth: '',
        orderid: '',
        category: 0,
        brand: '',
        commodity: '',
        product_date: '',
        effective_date: '',
        original_price: '',
        cost_price: '',
        agent_price: '',
        sale_price: '',
        stock: 1,
        remark: ''
      },
      dialog: false,
      categoryList: [
        {
          name: '正装',
          value: 0
        },
        {
          name: '小样',
          value: 1
        }
      ]
    }
  },
  methods: {
    // 公众号详情
    inboundDetail () {
      let params = {
        ibid: this.detail.ibid
      }
      this.loading = true
      inboundDetail(params).then((res) => {
        let data = res.data || {c: -1}
        console.log(data)
        if (!data.c) {
          this.detail = data.d.inbound
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    inboundEdit () {
      let content = ''
      if (this.detail.project === '') {
        content = '请填写项目名'
      }
      if (this.detail.brand === '') {
        content = '请填写品牌名'
      }
      if (this.detail.commodity === '') {
        content = '请填写商品'
      }
      if (this.detail.orderid === '') {
        content = '请填写订单号'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      let params = util.cloneObj(this.detail)
      inboundEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/inboundList')
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this.detail.ibid = parseInt(this.$route.query.ibid || 0)
    if (this.detail.ibid) {
      this.inboundDetail()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/stock/inboundEdit.vue